import type { ComponentProps } from 'react';
import { BackgroundMedia } from '../BackgroundMedia/BackgroundMedia';
import { DiscoverEntryBannerContainer } from '../DiscoverEntryBannerContainer/DiscoverEntryBannerContainer';
import { PlayButton, TitleSection } from './components';

type DiscoverEntryBannerProps = ComponentProps<typeof DiscoverEntryBannerContainer> & {
  href: string;
  image: string;
  gameName: string;
  title: string;
  label?: string;
  playButtonText: string;
  'data-testid'?: string;
  'data-track-container'?: string;
  'data-track-name'?: string;
};

function DiscoverEntryBanner({
  className,
  image,
  gameName,
  title,
  label,
  playButtonText,
  'data-testid': dataTestId,
  'data-track-container': dataTrackContainer,
  'data-track-name': dataTrackName,
  ...props
}: DiscoverEntryBannerProps) {
  return (
    <DiscoverEntryBannerContainer className={className} data-testid={dataTestId} data-track-container={dataTrackContainer} data-track-name={dataTrackName} {...props}>
      <BackgroundMedia image={image} gameName={gameName} className="-z-10" />
      <div className="flex flex-col items-center pt-14">
        <TitleSection title={title} label={label} />
        <PlayButton playButtonText={playButtonText} className="mt-12 md:mt-10" />
      </div>
    </DiscoverEntryBannerContainer>
  );
}

export { DiscoverEntryBanner };
export type { DiscoverEntryBannerProps };
